import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_MasterServicePlan = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_MasterServicePlan' className='file-pdf-document'>
            <div className='file-template'>
            <table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Admitting GAF Score:</span>
            <input type='text' id='txtAdmittingGAFScore' name='txtAdmittingGAFScore' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Current GAF Score:</span>
            <input type='text' id='txtCurrentGAFScore' name='txtCurrentGAFScore' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Current FARS Score:</span>
            <input type='text' id='txtCurrentFARSScore' name='txtCurrentFARSScore' className='add-only' />
        </td>
    </tr>
</table>
<h3>Diagnosis Code</h3>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>AXIS I:</span>
            <input type='text' id='txtDiagnosisCode_AXISI' name='txtDiagnosisCode_AXISI' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>AXIS II:</span>
            <input type='text' id='txtDiagnosisCode_AXISII' name='txtDiagnosisCode_AXISII' className='add-only' />
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <span className='eleHeader'>AXIS III:</span>
            <input type='text' id='txtDiagnosisCode_AXISIII' name='txtDiagnosisCode_AXISIII' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>AXIS IV:</span>
            <input type='text' id='txtDiagnosisCode_AXISIV' name='txtDiagnosisCode_AXISIV' className='add-only' />
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <span className='eleHeader'>AXIS V:</span>
            <input type='text' id='txtDiagnosisCode_AXISV' name='txtDiagnosisCode_AXISV' className='add-only' />
        </td>
        <td className='w-375'>&nbsp;</td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>AXIS I Diagnosis Narrative:</span>
    <textarea id='txtAXISIDiagnosisNarrative' name='txtAXISIDiagnosisNarrative' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Long-term View:</span>
    <textarea id='txtClientLongTermView' name='txtClientLongTermView' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Input from Family Members (if applicable):</span>
    <textarea id='txtInputFromFamilyMembers' name='txtInputFromFamilyMembers' className='add-only'></textarea>
</p>
<h3>Goals</h3>
<p className='w-750'>
    <span className='eleHeader'>1. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds1' name='txtClientProblemOrNeeds1' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal1' name='txtClientGoal1' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>2. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds2' name='txtClientProblemOrNeeds2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal2' name='txtClientGoal2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>3. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds3' name='txtClientProblemOrNeeds3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal3' name='txtClientGoal3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>4. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds4' name='txtClientProblemOrNeeds4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal4' name='txtClientGoal4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>5. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds5' name='txtClientProblemOrNeeds5' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal5' name='txtClientGoal5' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>6. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds6' name='txtClientProblemOrNeeds' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal6' name='txtClientGoal6' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>7. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds7' name='txtClientProblemOrNeeds7' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal7' name='txtClientGoal7' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>8. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds8' name='txtClientProblemOrNeeds8' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal8' name='txtClientGoal8' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>9. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds9' name='txtClientProblemOrNeeds9' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal9' name='txtClientGoal9' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>10. Client Problem/Needs:</span>
    <textarea id='txtClientProblemOrNeeds10' name='txtClientProblemOrNeeds10' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Goal #:</span>
    <textarea id='txtClientGoal10' name='txtClientGoal10' className='add-only'></textarea>
</p>
<h3>Client Objectives
	<span className='small block'>(Indicate measurable observable changes in target behavior. Example 1.1 or 1.2)
    </span>
</h3>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate1' name='txtClientobjectives_TargetDate1' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal1' name='txtClientobjectives_Goal1' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider1' name='txtClientobjectives_TreatmentProvider1' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_1' name='txtProgress_1' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives1' name='txtClientobjectives_ClientObjectives1' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate2' name='txtClientobjectives_TargetDate2' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal2' name='txtClientobjectives_Goal2' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider2' name='txtClientobjectives_TreatmentProvider2' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_2' name='txtProgress_2' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives2' name='txtClientobjectives_ClientObjectives2' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate3' name='txtClientobjectives_TargetDate3' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal3' name='txtClientobjectives_Goal3' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider3' name='txtClientobjectives_TreatmentProvider3' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_3' name='txtProgress_3' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives3' name='txtClientobjectives_ClientObjectives3' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate4' name='txtClientobjectives_TargetDate4' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal4' name='txtClientobjectives_Goal4' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider4' name='txtClientobjectives_TreatmentProvider4' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_4' name='txtProgress_4' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives4' name='txtClientobjectives_ClientObjectives4' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate5' name='txtClientobjectives_TargetDate5' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal5' name='txtClientobjectives_Goal5' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider5' name='txtClientobjectives_TreatmentProvider5' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_5' name='txtProgress_5' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives5' name='txtClientobjectives_ClientObjectives5' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate6' name='txtClientobjectives_TargetDate6' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal6' name='txtClientobjectives_Goal6' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider6' name='txtClientobjectives_TreatmentProvider6' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_6' name='txtProgress_6' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives6' name='txtClientobjectives_ClientObjectives6' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate7' name='txtClientobjectives_TargetDate7' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal7' name='txtClientobjectives_Goal7' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider7' name='txtClientobjectives_TreatmentProvider7' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_7' name='txtProgress_7' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives7' name='txtClientobjectives_ClientObjectives7' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate8' name='txtClientobjectives_TargetDate8' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal8' name='txtClientobjectives_Goal8' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider8' name='txtClientobjectives_TreatmentProvider8' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_8' name='txtProgress_8' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives8' name='txtClientobjectives_ClientObjectives8' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate9' name='txtClientobjectives_TargetDate9' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal9' name='txtClientobjectives_Goal9' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider9' name='txtClientobjectives_TreatmentProvider9' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_9' name='txtProgress_9' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives9' name='txtClientobjectives_ClientObjectives9' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate10' name='txtClientobjectives_TargetDate10' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal10' name='txtClientobjectives_Goal10' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider10' name='txtClientobjectives_TreatmentProvider10' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_10' name='txtProgress_10' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives10' name='txtClientobjectives_ClientObjectives10' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate11' name='txtClientobjectives_TargetDate11' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal11' name='txtClientobjectives_Goal11' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider11' name='txtClientobjectives_TreatmentProvider11' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_11' name='txtProgress_11' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives11' name='txtClientobjectives_ClientObjectives11' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-250'>
            <span className='eleHeader'>Target Date:</span>
            <input type='date' id='txtClientobjectives_TargetDate12' name='txtClientobjectives_TargetDate12' className='add-only' />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Goal #:</span>
            <input type='text' id='txtClientobjectives_Goal12' name='txtClientobjectives_Goal12' className='add-only'  />
        </td>
        <td className='w-250'>
            <span className='eleHeader'>Treatment Provider:</span>
            <input type='text' id='txtClientobjectives_TreatmentProvider12' name='txtClientobjectives_TreatmentProvider12' className='add-only'  />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Progress:</span>
    <textarea id='txtProgress_12' name='txtProgress_12' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Client Objectives:</span>
    <textarea id='txtClientobjectives_ClientObjectives12' name='txtClientobjectives_ClientObjectives12' className='add-only'></textarea>
</p>
<h3>Client Termination Criteria</h3>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_1' name='txtClientTerminationObj_1' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_1' name='txtClientTerminationDate_1' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_1' name='txtClientTerminationCriteria_1' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_2' name='txtClientTerminationObj_2' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_2' name='txtClientTerminationDate_2' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_2' name='txtClientTerminationCriteria_2' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_3' name='txtClientTerminationObj_3' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_3' name='txtClientTerminationDate_3' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_3' name='txtClientTerminationCriteria_3' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_4' name='txtClientTerminationObj_4' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_4' name='txtClientTerminationDate_4' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_4' name='txtClientTerminationCriteria_4' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_5' name='txtClientTerminationObj_5' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_5' name='txtClientTerminationDate_5' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_5' name='txtClientTerminationCriteria_5' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_6' name='txtClientTerminationObj_6' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_6' name='txtClientTerminationDate_6' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_6' name='txtClientTerminationCriteria_6' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_7' name='txtClientTerminationObj_7' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_7' name='txtClientTerminationDate_7' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_7' name='txtClientTerminationCriteria_7' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_8' name='txtClientTerminationObj_8' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_8' name='txtClientTerminationDate_8' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_8' name='txtClientTerminationCriteria_8' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_9' name='txtClientTerminationObj_9' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_9' name='txtClientTerminationDate_9' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_9' name='txtClientTerminationCriteria_9' className='add-only'></textarea>
</p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Objective #:</span>
            <input type='text' id='txtClientTerminationObj_10' name='txtClientTerminationObj_10' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Date Terminated:</span>
            <input type='date' id='txtClientTerminationDate_10' name='txtClientTerminationDate_10' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria:</span>
    <textarea id='txtClientTerminationCriteria_10' name='txtClientTerminationCriteria_10' className='add-only'></textarea>
</p>
<h3>Methods</h3>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>For Problem Numbers:</span>
            <input type='text' id='txtMethods_ForProblemNumbers' name='txtMethods_ForProblemNumbers' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Dated:</span>
            <input type='date' id='txtMethods_Dated' name='txtMethods_Dated' className='add-only' />
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-187'><span className='eleHeader'>Service Types</span></td>
        <td className='w-187'><span className='eleHeader'>Frequency</span></td>
        <td className='w-187'><span className='eleHeader'>Length of Session</span></td>
        <td className='w-187'><span className='eleHeader'>Duration of Treatment</span></td>
    </tr>
    <tr>
    <td className='w-187'>
            <input type='checkbox' id='cbSerType_1' name='cbSerType_1' className='add-only' value='ASSESSMENT/REVIEW' /> Assessment/Monitoring
        </td>
        <td className='w-187'>X
		<input type='text' id='txtFreqType_1' name='txtFreqType_1'  className='add-only w-150 custom-add-only'/> 
        
        </td>
        <td className='w-187'>
            <input type='text' id='txtHours_1_1' name='txtHours_1_1' className='add-only w-50 custom-add-only'/> Hour
            <input type='text' id='txtFreqType_1' name='txtFreqType_1'  className='add-only w-50 custom-add-only'/> Min

        </td>
        <td className='w-187'>
            <input type='text' id='txtDurOfTreatment_1' name='txtDurOfTreatment_1' className='add-only' />
        </td>
    </tr>
    <tr>
    <td className='w-187'>
            <input type='checkbox' id='cbSerType_2' name='cbSerType_2' className='add-only' value='MEDICATION MANAGEMENT/MONITORING' /> Medication Management/Monitoring
        </td>
        <td className='w-187'>X
			<input type='text' id='txtFreqType_2' name='txtFreqType_2'  className='add-only w-150 custom-add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txtHours_1_2' name='txtHours_1_2' className='add-only w-50 custom-add-only'/> Hour
            <input type='text' id='txtHours_1_2' name='txtHours_1_2' className='add-only w-50 custom-add-only'/> Min
            
        </td>
        <td className='w-187'>
            <input type='text' id='txtDurOfTreatment_2' name='txtDurOfTreatment_2' className='add-only'/>
        </td>
    </tr>
    <tr>
    <td className='w-187'>
            <input type='checkbox' id='cbSerType_3' name='cbSerType_3' className='add-only' value='PSYCHIATRIC EVALUATION/UPDATE'/>
            Psychiatric Evaluation
        </td>
        <td className='w-187'>X
			<input type='text' id='txtFreqType_3' name='txtFreqType_3'  className='add-only w-150 custom-add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txtHours_1_3' name='txtHours_1_3' className='add-only w-50 custom-add-only'/> Hour
            <input type='text' id='txtHours_1_3' name='txtHours_1_3' className='add-only w-50 custom-add-only'/> Min
           
        </td>
        <td className='w-187'>
            <input type='text' id='txtDurOfTreatment_3' name='txtDurOfTreatment_3' className='add-only' />
        </td>
    </tr>
    <tr>
    <td className='w-187'>
            <input type='checkbox' id='cbSerType_5' name='cbSerType_5' className='add-only' value='CASE MANAGEMENT/MONITORING' /> Case Management/Monitoring
        </td>
        <td className='w-187'>X
			<input type='text' id='txtFreqType_5' name='txtFreqType_5'  className='add-only w-150 custom-add-only'  />
        </td>
        <td className='w-187'>
            <input type='text' id='txtHours_1_5' name='txtHours_1_5' className='add-only w-50 custom-add-only'/> Hour
            <input type='text' id='txtHours_1_5' name='txtHours_1_5' className='add-only w-50 custom-add-only'/> Min
            
        </td>
        <td className='w-187'>
            <input type='text' id='txtDurOfTreatment_5' name='txtDurOfTreatment_5' className='add-only'/>
        </td>
    </tr>
    <tr>
    <td className='w-187'>
            <input type='checkbox' id='cbSerType_6' name='cbSerType_6' className='add-only' value='Other'/>
            Other:
			<input type='text' id='txtSerType_Other' className='add-only' name='txtSerType_Other'/>
        </td>
        <td className='w-187'>X
			<input type='text' id='txtFreqType_6' name='txtFreqType_6'  className='add-only w-150 custom-add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txtHours_1_6' name='txtHours_1_6' className='add-only w-50 custom-add-only'/> Hour
            <input type='text' id='txtHours_1_6' name='txtHours_1_6' className='add-only w-50 custom-add-only'/> Min
            
        </td>
        <td className='w-187'>
            <input type='text' id='txtDurOfTreatment_6' name='txtDurOfTreatment_6' className='add-only'  />
        </td>
    </tr>
</table>
<h5>Referral Agencies</h5>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Agency #1</span>
            <input type='text' id='txtRefAge_Agency1' name='txtRefAge_Agency1' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Phone Number</span>
            <input type='text' id='txtRefAge_PhoneNumber1' name='txtRefAge_PhoneNumber1' className='add-only' />
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <span className='eleHeader'>Agency #2</span>
            <input type='text' id='txtRefAge_Agency2' name='txtRefAge_Agency2' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Phone Number</span>
            <input type='text' id='txtRefAge_PhoneNumber2' name='txtRefAge_PhoneNumber2' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    I/We have participated in the development of this plan.
						<select id='ddlParticipated' name='ddlParticipated' className='add-only'>
                            <option value=''></option>
                            <option value='Yes'>Yes</option>
                            <option value='No'>No</option>
                        </select>
    Client Initials:
	<input type='text' id='txtPartInTheDevOfThisPlan_ClientInitials' name='txtPartInTheDevOfThisPlan_ClientInitials' className='add-only' />
</p>
<p className='w-750'>
    I/We have received a copy of this plan.
						<select id='ddlReceivedCopy' name='ddlReceivedCopy' className='add-only'>
                            <option value=''></option>
                            <option value='Yes'>Yes</option>
                            <option value='No'>No</option>
                        </select>
    Client Initials:
	<input type='text' id='txtReceivedACopyOfThisPlan_ClientInitials' name='txtReceivedACopyOfThisPlan_ClientInitials' className='add-only' />
</p>
<p className='w-750'>This is to certify that the Services prescribed and recommended in this treatment plan are appropriate and medically necessary to meet the recipientâ€™s need, as defined by the Florida Medicaid Program.</p>
<p className='w-750'>
    Review Update Due
	<input type='text' id='txtReviewUpdateDue' name='txtReviewUpdateDue' className='add-only' />
</p>


                
            </div>
        </form>

    )
}











